import type { Action } from "./types";
import { router } from "../../App";

/**
 * Opens the curve editor, navigating same-tab to the in-app Curve Management
 * page via the router.
 */
export const editCurve: Action = (ctx) => {
  if (ctx.disabledFeatures?.editCurve || !ctx.productId) return;

  router.navigate({
    to: "/app/curve-management",
    search: { mode: "edit", edit: ctx.productId },
  });
};
